<template>
  <div class="row">
    <div class="col-sm-6">
    <div class="card"
    id="printMe"
    v-loading="loading"
    element-loading-text="Wird geladen..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div class="card-header">
      <div class="row">
        <div class="col-sm-8">
          <p-button type="default" link style="float: left;" @click="navigateBack()" class="hidePrint"><i class="bi bi-arrow-left" style="font-size: 16px;"></i></p-button><h5 class="card-title" v-if="mode == 'new'">Neuer Mangel</h5>
          <h5 class="card-title mb-0" v-if="mode == 'edit'">{{defectParcours}}: {{ defectTitle }} ({{ defectStatus }}) <i v-if="timeTrackingActive" class="bi bi-stopwatch" title="Zeiterfassung aktiv" style="color: green;"></i></h5>
          <span class="card-subtitle text-muted" v-if="mode == 'edit'">Erfasst am: {{ defectDate }}</span>
        </div>
        <div class="col-sm-4 text-right">
          <p-button type="default" link v-print="'#printMe'" title="Drucken" class="hidePrint"><i class="bi bi-printer-fill" style="font-size: 16px;"></i></p-button>
          <p-button type="default" link @click="removeDefect" title="Mangel löschen" v-if="constructionRole == 4" class="hidePrint"><i class="bi bi-trash" style="font-size: 16px;"></i></p-button>
        </div>
      </div>
    </div>
      <div class="card-body">
        <ValidationObserver ref="form">
          <form @submit.prevent="validate">
            <div class="row pb-2">
              <div class="col-sm-6">
                <ValidationProvider name="defectParcours" rules="required" v-slot="{ errors }">
                  <label>Parcours</label>
                  <el-select class="select" placeholder="Parcours wählen" v-model="defectParcours" @change="loadElements" :disabled="defectStatus == 'Erledigt' || $route.params.parcoursName != null || constructionRole < 2">
                    <el-option v-for="p in parcours" :label="p.Name" :value="p.Name" :key="p.key"></el-option>
                  </el-select>
                  <span class="invalid mt-2">{{
                    errors[0]
                      ? "Der betroffene Parcours muss ausgewählt werden."
                      : null
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="col-sm-6">
                <ValidationProvider name="defectElement" rules="required" v-slot="{ errors }">
                  <label>Plattform/Element</label>
                  <el-select class="select" placeholder="Plattform/Element wählen" v-model="defectElement" :disabled="defectParcours == '' || defectStatus == 'Erledigt' || $route.params.elementName != null || constructionRole < 2">
                    <el-option v-for="e in elements" :label="e.elementName" :value="e.elementName" :key="e.key"></el-option>
                  </el-select>
                  <span class="invalid mt-2">{{
                    errors[0]
                      ? "Das betroffene Element/Plattform muss ausgewählt werden."
                      : null
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-sm-12">
                <ValidationProvider name="defectTitle" rules="required" v-slot="{ failed }">
                  <fg-input type="text" label="Titel/Kurzbeschreibung" v-model="defectTitle" :error="failed ? 'Titel/Kurzbeschreibung muss angegeben werden.' : null" :disabled="defectStatus == 'Erledigt' || constructionRole < 2"></fg-input>
                </ValidationProvider>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-sm-12">
                <label>Ausführliche Beschreibung</label>
                  <textarea class="form-control px-2" placeholder="Ausführliche Beschreibung des Mangels..." rows="4" v-model="defectDescription" :disabled="defectStatus == 'Erledigt' || constructionRole < 2"></textarea>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-sm-4">
                <label>Priorität</label>
                <ValidationProvider name="defectPrio" rules="required" v-slot="{ errors }">
                  <el-select class="select" placeholder="Priorität wählen" v-model="defectPrio" :disabled="defectStatus == 'Erledigt' || constructionRole < 2">
                    <el-option label="Hoch" value="Hoch" key="Hoch"></el-option>
                    <el-option label="Mittel" value="Mittel" key="Mittel"></el-option>
                    <el-option label="Niedrig" value="Niedrig" key="Niedrig"></el-option>
                  </el-select>
                  <span class="invalid mt-2">{{
                    errors[0]
                      ? "Die Priorität muss ausgewählt werden."
                      : null
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="col-sm-4">
                <label>Bearbeiter</label>
                <el-select
                  class="select"
                  placeholder="Bearbeiter wählen"
                  filterable
                  v-model="defectAssignedTo"
                  :disabled="defectStatus != 'In Arbeit' || constructionRole < 2"
                >
                  <el-option
                    v-for="option in trainer"
                    class="select"
                    :value="option.trainerName"
                    :label="option.trainerName"
                    :key="option.trainerName"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-sm-4">
                <fg-input type="text" label="Status" v-model="defectStatus" disabled></fg-input>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-sm-4">
                <fg-input type="time" label="Geschätzter Aufwand" v-model="defectEffort" min="00:00" max="20:00" step="900" :disabled="defectStatus == 'Erledigt' || constructionRole < 2"></fg-input>
              </div>
              <div class="col-sm-4">
                <fg-input type="time" label="Tatsächlicher Aufwand" v-model="defectEffortActual" min="00:00" disabled></fg-input>
              </div>
            </div>
            <div class="row pb-0">
              <LightGallery :images="defectPhotos" :index="photoIndex" :disable-scroll="true" @close="photoIndex = null"/>
                <ul>
                  <li v-for="(thumb, thumbIndex) in defectPhotos" :key="thumbIndex" @click="photoIndex = thumbIndex" class="thumb">
                    <img :src="thumb" width="100" height="100" class="img-thumbnail " style="cursor: pointer;" />
                  </li>
              </ul>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <image-uploader
                  :debug="2"
                  :maxWidth="1024"
                  :quality="0.7"
                  :autoRotate=true
                  outputFormat="verbose"
                  :preview=false
                  :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
                  accept="image/*"
                  doNotResize="['gif', 'svg']"
                  @input="addPic"
                >
                <label for="fileInput" slot="upload-label" ref="imageUploader"></label>
              </image-uploader>
              <div class="py-3" v-if="uploading">
                <el-progress :percentage="uploadProgress" :stroke-width="10" color="#15a34a"></el-progress>
              </div>
              <p-button type="default" block @click="chooseFile" :disabled="uploading || constructionRole < 2" v-if="defectStatus != 'Erledigt'" class="hidePrint">Foto hinzufügen</p-button>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <p-button type="success" @click="validate()" block v-if="defectStatus != 'Erledigt'" class="hidePrint">Speichern</p-button>
              </div>
              <div class="col-sm-6">
                <p-button type="success" @click="saveDefect(backToInspection = true)" block v-if="defectStatus != 'Erledigt' && mode == 'new' && inspectionId != '' && constructionRole >= 2" class="hidePrint">Speichern & zurück zur Inspektion</p-button>
                <p-button type="default" @click="setWIP()" block v-if="defectStatus == 'Neu' && mode == 'edit' && constructionRole >= 2" class="hidePrint">In Arbeit</p-button>
                <p-button type="default" @click="setDone()" block v-if="defectStatus == 'In Arbeit' && mode == 'edit' && constructionRole >= 2" class="hidePrint">Erledigt</p-button>
                <p-button type="default" @click="setAccepted()" block v-if="defectStatus == 'Zur Abnahme' && mode == 'edit' && constructionRole >= 2" class="hidePrint">Abnahme</p-button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 pt-1">
                <p-button type="default" @click="startTimeTracking()" block v-if="!timeTrackingActive && defectStatus == 'In Arbeit' && mode == 'edit'" class="hidePrint">Zeiterfassung starten</p-button>
                <p-button type="warning" @click="stopTimeTracking()" block v-if="timeTrackingActive && defectStatus == 'In Arbeit' && mode == 'edit'" class="hidePrint">Zeiterfassung stoppen</p-button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    </div>
        <div class="col-sm-6">
          <time-line type="">
            <time-line-item
              :class="index % 2 == 1 ? 'timeline-inverted' : 'timeline'"
              v-for="(action, index) in defectActionHistory"
              :key="action.key"
              badgeType="success"
              :badgeIcon="action.actionIcon"
            >
            <badge slot="header" type="success"><b>{{ action.actionDate }}</b></badge>
            <p slot="content" style="white-space: pre-line;" class="pt-3">
              <i>{{ action.actionNote}}</i></p>
            <small slot="footer" class="text-muted"><i class="bi bi-person-fill"></i> {{ action.actionUser }}</small>
          </time-line-item>
        </time-line>
        </div>

      <modal :show.sync="showDoneModal" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">Mangel erledigt</h5>
      <div class="row">
        <div class="col">
          <label class="pt-4">Kommentare / durchgeführte Reparaturen / Beobachtungen:</label>
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 8}" placeholder="Kommentare/durchgeführte Reparaturen/Beobachtungen..." v-model="newActionNote"></el-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col">
          <el-checkbox v-model="defectReview">Abnahme anfordern</el-checkbox>
        </div>
      </div>
      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showDoneModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="setDoneConfirm()">Speichern</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="showReviewModal" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">Abnahme</h5>
      <div class="row pt-3">
        <div class="col">
          <label class="pt-4">Ergebnis der Abnahme:</label>
          <el-radio-group v-model="defectReviewResult" block>
            <el-radio-button label="Abnahme erteilt" block></el-radio-button>
            <el-radio-button label="Abnahme abgelehnt"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="row" v-if="defectReviewResult == 'Abnahme abgelehnt'">
        <div class="col">
          <label class="pt-4">Anmerkungen/Grund der Ablehnung:</label>
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 8}" placeholder="Anmerkungen..." v-model="newActionNote"></el-input>
        </div>
      </div>
      
      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showReviewModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="setAcceptedConfirm()">Speichern</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db, FirebaseStorage } from "../../../../firebaseDb";
import { Table, TableColumn, Input, Loading, Popover, Tag, MessageBox, Select, Option, Image, Progress} from "element-ui";
import { TimeLine, TimeLineItem, Badge, Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import { set } from "nprogress";
import { LightGallery } from 'vue-light-gallery';
import ImageUploader from 'vue-image-upload-resize'
import Print from 'vue-print-nb'
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)
Vue.use(Print)

export default {
  components: {
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    TimeLine,
    TimeLineItem,
    Badge,
    Modal,
    [Progress.name]: Progress,
    MessageBox,
    Image,
    LightGallery,
    ImageUploader,
  },

  data() {
    return {
      defectId: 0,
      mode: 'new',
      defectParcours: '',
      defectElement: '',
      defectTitle: '',
      defectDescription: '',
      defectStatus: 'Neu',
      defectPrio: 'Mittel',
      defectDate: '',
      defectAssignedTo: '',
      defectPhotos: [],
      defectActionHistory: [],
      defectReview: false,
      defectReviewResult: '',
      defectEffort: this.convertDecimalToTime(0),
      defectEffortActual: 0,
      timeTrackingActive: false,
      loading: true,
      parcours: [],
      elements: [],
      trainer: [],
      location: store.getters.userlocation,
      uploadFiledata: null,
      uploadValue: 0,
      uploading: false,
      showNewActionModal: false,
      showReviewModal: false,
      newActionNote: '',
      showDoneModal: false,
      photoIndex: null,
      hasImage: false,
      uploadProgress: 0,
      pickerOptionsMaintenance: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          firstDayOfWeek: 1,
          shortcuts: []
        },
      constructionRole: store.getters.constructionRole,
    };
  },
  created() {
    if(store.getters.constructionRole == "0") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    } else {
      this.defectId = this.$route.params.defectId || "";
      this.mode = this.$route.params.mode || 'new';
      this.inspectionId = this.$route.params.inspectionId || "";
      this.parcoursId = this.$route.params.parcoursId || "";
      this.defectParcours = this.$route.params.parcoursName || "";
      this.defectElement = this.$route.params.elementName || "";
      this.loadParcours();
      this.loadTrainers();
      moment.locale("de");
      if (this.mode == 'edit') {
        this.loadDefect()
      } else {
        this.loading = false;
      }
      store.watch(
        (state) => state.userlocation,
        () => {
          this.location = store.getters.userlocation;
          if (this.mode == 'edit') {
            this.loadDefect();
          }
        }
      );
    }
  },
  methods: {
    newAction() {
      this.showNewActionModal = true;
    },
    navigateBack() {
      router.go(-1);
    },
    loadDefect() {
      // get defect data from firebase
      const defectRef = db.collection("constructionDefects");
      defectRef.doc(this.defectId).get().then((doc) => {
        this.defectParcours = doc.data().Parcours
        this.defectElement = doc.data().Element
        this.defectTitle = doc.data().Title
        this.defectDescription = doc.data().Description
        this.defectStatus = doc.data().Status
        this.defectPrio = doc.data().Prio
        this.defectPhotos = doc.data().Photos || [];
        this.defectDate = moment(new Date(doc.data().Date.seconds * 1000)).format("DD.MM.yyyy").toString(),
        this.defectAssignedTo = doc.data().AssignedTo || "-";
        this.defectEffort = doc.data().Effort || 0;
        this.defectEffortActual = doc.data().EffortActual || 0;
        this.defectEffort = this.convertDecimalToTime(this.defectEffort);
        this.defectEffortActual = this.convertDecimalToTime(this.defectEffortActual);
        this.timeTrackingActive = doc.data().TimeTrackingActive || false;
        this.defectActionHistory = []
        db.collection("constructionDefects").doc(this.defectId).collection("actions").orderBy("Date", "desc").get().then((snapshot) => {
          snapshot.forEach((doc) => {
            this.defectActionHistory.push({
              key: doc.id,
              actionDate: moment(new Date(doc.data().Date.seconds * 1000)).format("DD. MMM yyyy HH:mm").toString(),
              actionUser: doc.data().User,
              actionType: doc.data().Type,
              actionNote: doc.data().Note || "-",
              actionIcon: doc.data().Type == 'Neu' ? 'timeline-icon bi bi-plus-circle' :
                          doc.data().Type == 'In Arbeit' ? 'timeline-icon bi bi-wrench' :
                          doc.data().Type == 'Erledigt' ? 'timeline-icon bi bi-check-circle' :
                          doc.data().Type == 'Zur Abnahme' ? 'timeline-icon bi bi-clipboard-check' :
                          'timeline-icon bi bi-info-circle',
            })
          });
        });

        this.loading = false
      });
    },
    loadParcours() {
      // get parcours data from firebase
      db.collection("parcours").where('locationID', '==', store.getters.userlocation).orderBy('position').get().then((snapshot) => {
        this.parcours = [];
        snapshot.forEach((doc) => {
          this.parcours.push({
            Name: doc.data().Name,
            key: doc.id,
          });
        });
      });
    },
    loadElements() {
      if (this.$route.params.elementName) {
        this.defectElement = this.$route.params.elementName;
      } else {
        const parcKey = this.parcours.find(p => p.Name === this.defectParcours).key
      // get elements data from firebase
      this.elements = [];
        // Fetch elements for each parcours from subcollection 'elements'
        const elementsRef = db.collection("parcours").doc(parcKey).collection("elements");
        elementsRef.orderBy("elementPosition").get().then((elementsSnapshot) => {
          elementsSnapshot.forEach((elementDoc) => {
            this.elements.push({
              key: elementDoc.id,
              elementPosition: elementDoc.data().elementPosition,
              elementName: elementDoc.data().elementName,
              elementType: elementDoc.data().elementType,
            });
          });
        });
      }
    },
    loadTrainers() {
      // get list of trainers
      const trainerRef = db.collection("trainer");
      trainerRef
        //.where("isConstruction", "==", true)
        .where('locationID', 'array-contains', this.location)
        .orderBy("Name")
        .onSnapshot((snapshotChange) => {
          this.trainer = [];
          snapshotChange.forEach((doc) => {
            this.trainer.push({
              trainerName: doc.data().Name,
            });
          });
        });
    },
    addPic(file) {
      if (this.mode != 'edit') {
        this.saveDefect();
      }
      this.hasImage = true;
      const fileNameParts = file.info.name.split(".");
      const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();
      const fileData = file.dataUrl;
      // upload the photo to firebase storage and get the URL
      this.uploading = true;
      const filename = Date.now() + "_" + store.getters.user.data.uid + "." + fileExtension;
      const storageRef = FirebaseStorage.ref("/defects/" + filename).putString(fileData, 'data_url');
      storageRef.on('state_changed', snapshot => {
        this.uploadProgress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      }, error => { console.log(error.message) },
        () => {
          this.uploadProgress = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.defectPhotos.push(url);
            db.collection("constructionDefects").doc(this.defectId).update({
              Photos: this.defectPhotos,
            }).then(() => {
              this.hasImage = null;
              this.uploading = false;
            }).catch(() => {
                console.log("Error adding document with attachment " + error);
              });
          });
        }
      );
    },
    chooseFile() {
      this.$refs.imageUploader.click();
    },
    prepareFile(event) {
      this.uploadValue = 0;
      this.uploadFiledata = event.target.files[0];
    },
    setWIP() {
      this.defectStatus = 'In Arbeit';
      this.defectAssignedTo = store.getters.user.data.displayName;
      this.saveDefect();
      db.collection("constructionDefects").doc(this.defectId).collection("actions").add({
            Date: new Date(),
            User: store.getters.user.data.displayName,
            Note: "Mangel ist in Bearbeitung. Bearbeiter: " + this.defectAssignedTo,
            Type: "In Arbeit"
          })
    },
    removeDefect() {
      MessageBox.confirm(
        "Soll dieser Mangel wirklich gelöscht werden? Dieser Vorgang kann nicht rückgängig gemacht werden.",
        "Mangel löschen",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
        }
      ).then(() => {
        db.collection("constructionDefects").doc(this.defectId).delete().then(() => {
          this.navigateBack();
        });
      }).catch(() => {
        // cancelled
      });
    },
    startTimeTracking() {
      this.timeTrackingActive = true;
      db.collection("constructionDefects").doc(this.defectId).update({
        TimeTrackingActive: true,
      });
      db.collection("constructionDefects").doc(this.defectId).collection("timeTracking").add({
            Start: new Date(),
            User: store.getters.user.data.displayName,
            End: null,
            Duration: null,
          })
    },
    stopTimeTracking() {
      this.timeTrackingActive = false;
      const timeTrackingRef = db.collection("constructionDefects").doc(this.defectId).collection("timeTracking");
      timeTrackingRef.where('End', '==', null).where('User', '==', store.getters.user.data.displayName).get().then((snapshot) => {
        snapshot.forEach((doc) => {
          const startTime = doc.data().Start.toDate();
          const endTime = new Date();
          const durationMs = endTime - startTime;
          const durationHours = Math.round((durationMs / (1000 * 60 * 60)) * 100) / 100; // round to 2 decimals
          timeTrackingRef.doc(doc.id).update({
            End: endTime,
            Duration: durationHours,
          });
          // update actual effort
          const defectEffortActualDecimal = this.convertTimeToDecimal(this.defectEffortActual) + durationHours;
          this.defectEffortActual = this.convertDecimalToTime(defectEffortActualDecimal);
          db.collection("constructionDefects").doc(this.defectId).update({
            EffortActual: defectEffortActualDecimal,
            TimeTrackingActive: false,
          });
        });
      });
    },
    convertDecimalToTime(decimal) {
      const hours = Math.floor(decimal);
      const minutes = Math.round((decimal - hours) * 60);
      return ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2);
    },
    convertTimeToDecimal(time) {
      if (typeof time === 'number') {
        return time; // already decimal
      }
      const parts = time.split(":");
      const hours = parseInt(parts[0]);
      const minutes = parseInt(parts[1]);
      return hours + (minutes / 60);
    },
    setDone() {
      this.showDoneModal = true;
    },
    setDoneConfirm() {
      this.showDoneModal = false;
      if (this.defectReview == true) {
        this.defectStatus = 'Zur Abnahme';
        let note = "Mangel wurde behoben, Abnahme offen."
        if (this.newActionNote != '') {
          note = this.newActionNote
        }
        db.collection("constructionDefects").doc(this.defectId).collection("actions").add({
                    Date: new Date(),
                    User: store.getters.user.data.displayName,
                    Note: note,
                    Type: "Zur Abnahme"
                  })
      } else {
        this.defectStatus = 'Erledigt';
        let note = "Mangel wurde behoben."
        if (this.newActionNote != '') {
          note = this.newActionNote
        }
        db.collection("constructionDefects").doc(this.defectId).collection("actions").add({
                    Date: new Date(),
                    User: store.getters.user.data.displayName,
                    Note: note,
                    Type: "Erledigt"
                  })
      }
      this.saveDefect();
      this.newActionNote = '';
      this.defectReview = false;
    },
    setAccepted() {
      this.showReviewModal = true;
    },
    setAcceptedConfirm() {
      this.showReviewModal = false;
      if (this.defectReviewResult == 'Abnahme erteilt') {
        this.defectStatus = 'Erledigt';
        let note = "Abnahme erfolgreich."
        db.collection("constructionDefects").doc(this.defectId).collection("actions").add({
                    Date: new Date(),
                    User: store.getters.user.data.displayName,
                    Note: note,
                    Type: "Erledigt"
                  })
      } else {
        this.defectStatus = 'In Arbeit';
        let note = "Abnahme abgelehnt. " + this.newActionNote
        db.collection("constructionDefects").doc(this.defectId).collection("actions").add({
                    Date: new Date(),
                    User: store.getters.user.data.displayName,
                    Note: note,
                    Type: "In Arbeit"
                  })
      }
      this.saveDefect();
      this.defectReviewResult = '';
      this.newActionNote = '';
    },
    validate() {
      return this.$refs.form.validate().then((res) => {
        if (res) {
          this.saveDefect();
        }
      });
    },
    saveDefect(backToInspection = false) {
      if (this.mode == 'new') {
        let inspection = 0;
        if(this.inspectionId != '') {
          inspection = this.inspectionId;
        }
        // create new defect
        db.collection("constructionDefects").add({
          Parcours: this.defectParcours,
          Element: this.defectElement,
          Title: this.defectTitle,
          Description: this.defectDescription,
          Status: this.defectStatus,
          Prio: this.defectPrio,
          Date: new Date(),
          AssignedTo: this.defectAssignedTo,
          locationID: store.getters.userlocation,
          Effort: this.convertTimeToDecimal(this.defectEffort),
          EffortActual: 0,
          Photos: [],
          InspectionId: inspection,
        }).then((docRef) => {
          this.defectId = docRef.id;
          db.collection("constructionDefects").doc(this.defectId).collection("actions").add({
            Date: new Date(),
            User: store.getters.user.data.displayName,
            Note: "Mangel wurde erfasst.",
            Type: "Neu"
          }).then(() => {
            if (backToInspection) {
              router.push({ name: 'InspectionCheck', params: { inspectionId: this.inspectionId, parcoursId: this.parcoursId} });
            } else {
              this.loadDefect();
              this.mode = 'edit';
              this.$notify({
                message: "Mangel wurde erfolgreich erstellt!",
                icon: "fa fa-check-circle",
                horizontalAlign: "right",
                verticalAlign: "bottom",
                type: "success",
                showClose: true,
                timeout: 5000,
              });
            }
          }).catch(() => {
            this.$notify({
              message: "Fehler beim Speichern des Mangels! Bitte Internetverbindung prüfen.",
              icon: "fa fa-exclamation-circle",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
              showClose: true,
              timeout: 10000,
            });
          });
        });
          
      } else {
        // update existing defect
        db.collection("constructionDefects").doc(this.defectId).update({
          Parcours: this.defectParcours,
          Element: this.defectElement,
          Title: this.defectTitle,
          Description: this.defectDescription,
          Status: this.defectStatus,
          Prio: this.defectPrio,
          AssignedTo: this.defectAssignedTo,
          Effort: this.convertTimeToDecimal(this.defectEffort),
        }).then(() => {
          this.$notify({
            message: "Mangel wurde erfolgreich aktualisiert!",
            icon: "fa fa-check-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success",
            showClose: true,
            timeout: 5000,
          });
          this.loadDefect();
        }).catch(() => {
          this.$notify({
            message: "Fehler beim Speichern des Mangels! Bitte Internetverbindung prüfen.",
            icon: "fa fa-exclamation-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
            showClose: true,
            timeout: 10000,
          });
        });
      }
    },
  },
};
</script>
<style>
.el-tag {
  color: white !important;
  margin-left: 0px !important;
}
.timeline-icon {
  line-height: 2.1;
  width: 25px;
  text-align: center;
  font-size: 22px;
}
.el-descriptions-item__label {
  font-weight: bold;
}
.timeline-heading {
  margin-bottom: 0px !important;
}
.el-radio-button__inner {
  width: 100% !important;
}
.el-radio-group {
  width: 100% !important;
}
.el-radio-button {
  width: 50% !important;
}
.thumb {
  display: inline-block;
  margin: 5px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 3px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}
.img-preview {
  max-width: 200px;
  max-height: 200px;
}
#fileInput {
  display: none!important;
}
.hidePrint {
  @media print {
    display: none;
  }
}
</style>
